module.exports = __webpack_public_path__ + "media/images/common/ico-light-66de93a5325c213d9546779faca3002d.svg";